import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ListingCard from "@/components/listings/ListingCard";
import FiltersSidebar from "@/components/listings/FiltersSidebar";
import { Loader2 } from "lucide-react";
import { fetchListings } from "@/lib/api";

function toParams(f, q) {
  const p = { limit: 48 };
  if (q) p.q = q;
  if (f.subcategory) p.subcategory = f.subcategory;
  if (f.county) p.county = f.county;
  if (f.city) p.city = f.city;
  if (f.minPrice) p.min = f.minPrice;
  if (f.maxPrice) p.max = f.maxPrice;
  if (f.conditions?.length) p.conditions = f.conditions.join(",");
  if (f.onlyFeatured) p.featured = 1;
  if (f.sort) p.sort = f.sort;
  return p;
}

export default function SearchResults() {
  const [sp] = useSearchParams();
  const q = sp.get("q") || "";
  const countyParam = sp.get("county") || "";
  const cityParam = sp.get("city") || "";
  const featuredParam = sp.get("featured") === "1";

  const [filters, setFilters] = useState({
    county: countyParam, city: cityParam, subcategory: "", minPrice: "", maxPrice: "",
    conditions: [], onlyFeatured: featuredParam, sort: "newest",
  });
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { setFilters((f) => ({ ...f, county: countyParam, city: cityParam, onlyFeatured: featuredParam })); }, [countyParam, cityParam, featuredParam]);

  useEffect(() => {
    setLoading(true);
    fetchListings(toParams(filters, q))
      .then((d) => setItems(d.items || []))
      .finally(() => setLoading(false));
  }, [filters, q]);

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 md:py-8 fade-in">
      <h1 className="text-xl md:text-2xl font-black text-white">
        {q ? <>Rezultate pentru „<span style={{ color: "var(--amd-primary)" }}>{q}</span>”</> : "Toate anunțurile"}
      </h1>
      <p className="mt-1 text-sm" style={{ color: "var(--amd-text-muted)" }}>{loading ? "se caută…" : `${items.length} anunțuri găsite`}</p>

      <div className="mt-6 flex flex-col lg:flex-row gap-6">
        <FiltersSidebar filters={filters} setFilters={setFilters} />
        <div className="flex-1 min-w-0">
          {loading ? (
            <div className="py-16 text-center"><Loader2 className="w-7 h-7 mx-auto animate-spin" style={{ color: "var(--amd-primary)" }} /></div>
          ) : items.length === 0 ? (
            <div className="amd-card rounded-lg p-10 text-center">
              <div className="font-bold text-white text-lg">Niciun rezultat</div>
              <p className="mt-1 text-sm" style={{ color: "var(--amd-text-muted)" }}>Încearcă alt cuvânt cheie sau filtre.</p>
            </div>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
              {items.map((l) => <ListingCard key={l.id} listing={l} />)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
